module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-1.d382eb44.jpg";